export class PayslipData {
    constructor(arg) {
        Object.assign(this, arg);
        this.datePayment = new Date(this.datePayment);
    }
}
